import React from 'react';
import { Segment, Grid, Divider, Input, Button, List, Icon, Label, Popup, Message, Confirm, Header } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { isPanelChangePeriod } from '../../util/helpers'
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { PANELCHANGER_BASEURL } from '../../constants/system'
import PanelConsentContainer from '../panelConsent/panelConsentContainer'
import SegmentationCharts from '../common/SegmentationCharts'

/**
 * Panel component
 */
export default class Panel extends React.Component {

	newPanelData = {
		labels: ['A (22)', 'B (19)'],
		datasets: [
		  {
			label: 'Aktuális A/B',
			data: [22, 19],
			backgroundColor: [
				'#2B662D',
				'#2085D0'
			]
		  },
		],
	}

	/**
     * Constructor
     * @param {*} props 
     */
	constructor(props) {
		super(props);

		this.state = {
			filterString: '',
			showAll: true,
			openRemoveTargetDialog: false,
			actualPanelABRatio: {}
		}
	}

	handleShowConfirmRemoveTarget = (id) => this.setState({ openRemoveTargetDialog: true, removeTargetId: id })
	handleCloseConfirmRemoveTarget = () => this.setState({ openRemoveTargetDialog: false, removeTargetId: undefined })
	handleConfirmedRemoveTarget = () => { this.handlePanelChangeRemoveTarget(this.state.removeTargetId); this.setState({ openRemoveTargetDialog: false, isProcessing: true }); }
  
	/**
	 * Remove a panel change
	 */
	handlePanelChangeRemoveTarget(license) {
		this.props.panelChangeRemoveTarget(license, this.props.visitorTerritory)
	}		

	/**
	 * Handle filter changes
	 * @param {*} e 
	 */
	handleFilterChange(e) {
		this.setState({ ...this.state, filterString: e.target.value, showAll: e.target.value.length === 0 });
	}
	
	/**
	 * Initialize
	 */
	componentDidMount() {
		this.props.clearPanelUi();
		this.props.clearPanelChangeUi();
		this.props.clearRequestUi();

		// Fetch panel if needed
		//if (this.props.actualPanel.length === 0)
		//{
			this.props.fetchPanel(this.props.visitorTerritory);
			this.props.fetchPanelForExport(this.props.visitorTerritory);
		//}

		// Fetch settings
		if (!this.props.isSettingsLoaded)
		{
			this.props.fetchSettings();
		}

		// Re-map this prop to the state even when no prop change is happened (no fetch)
		this.setState({ ...this.state, isPanelOpen: this.props.isPanelOpen })

		document.getElementById('panel.filterString').focus();
	}

	componentWillUnmount() {
		this.props.clearPanelUi();
		this.props.clearPanelChangeUi();
		this.props.clearRequestUi();
	}

	/**
	 * Filter target list
	 * @param {*} filter 
	 */
	filterTargets(actualPanel, filter) {
		var byName = actualPanel.filter( target => target.name.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
		var byLicense = actualPanel.filter( target => target.license.toLowerCase().indexOf(filter.toLowerCase()) !== -1);

		return byName.concat(byLicense);
	}

	/**
	 * Data update - maybe we have fetched day data?
	 * @param {*} prevProps 
	 */
	componentDidUpdate(prevProps) {
		if (prevProps.isPanelOpen !== this.props.isPanelOpen)
		{
			this.setState({ ...this.state, isPanelOpen: this.props.isPanelOpen })
		}
	}
	
	/**
	 * Export data into xlsx.s
	 */
	exportPanel() {
		const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
	  	const fileExtension = '.xlsx';
	
		fetch(PANELCHANGER_BASEURL + '/panel/' + this.props.visitorTerritory + '/export/all', { headers: { 'Token': localStorage.getItem('token') }}).then(response => response.json()).then(data => {

			const dataFiltered = Array.isArray(data)
				? data.map(row => {
					const { gdprConsent, intact, ...rest } = row;
					return rest;
				})
				: data;
			const ws = XLSX.utils.json_to_sheet(dataFiltered);
	
			const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
			const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
			const excel = new Blob([excelBuffer], { type: fileType });
			FileSaver.saveAs(excel, 'export_' + this.props.visitorTerritory + fileExtension);

		}).catch(error => { alert('Hiba! ' + error); console.error(error) });
	}

	render() {		

		const panel = (this.state.showAll ?
					   this.props.actualPanel
					   :
					   this.state.filterString.length < 2 ?
					   []
					   :
					   this.filterTargets(this.props.actualPanel, this.state.filterString))

		return <Segment basic loading={ this.props.isLoading || this.props.isSaving || this.state.isProcessing }>
			{ this.props.errorPanelChange === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanelChange }</Message> }								
			{ this.props.errorPanel === undefined ? '' : <Message error>Hiba történt. { this.props.errorPanel }</Message> }								
			{ !this.state.isPanelOpen && !isPanelChangePeriod() ? <Message info>Jelenleg <b>nincsen</b> panelváltoztatási időszak. Frekvencia csökkentés kérése a szokott módon igényelhető.</Message> : '' }
			{ this.props.role !== 'Admin' && this.props.role !== 'RSM' ? <PanelConsentContainer /> : '' }
			<Input
				id='panel.filterString' 
				onChange={ (e) => this.handleFilterChange(e) } 
				placeholder='Név? Pecsétszám? Névtöredék?'
				>
				<input style={{ width: '200px' }} />&nbsp;
			</Input>
			<Popup content='Panel exportálása Excelbe' position='top right' trigger={<Button disabled={ this.props.panelForExport === undefined || this.props.panelForExport.length === 0 } onClick={ () => this.exportPanel() } floated='right' color='green' icon><Icon name='file excel' /></Button>}/>
			<Link to='/showChanges'>
				<Popup content='Igények áttekintése' position='top right' trigger={<Button floated='right' primary icon><Icon name='exchange' /></Button>}/>
			</Link>
			<Link to={ '/addPanelTarget/' + this.props.visitorTerritory }>
				<Popup content='Új célpont vagy cím felvétele' position='top right' trigger={<Button icon color='green' floated='right'><Icon name='plus'/></Button>}/>
			</Link>
			<Divider/>
			<Grid stackable>
				<Grid.Row stretched>
					<Grid.Column width={12}>
						<List divided relaxed='very' verticalAlign='middle'>
						{
							this.state.filterString.length > 1 || this.state.showAll ?
							''
							:
							<Segment placeholder>
								<Header icon style={{ color: '#aaa' }}>
									<Icon name='eye' />
									Írd be kit keresel a paneledben.
								</Header>
							</Segment>
						}
						{
							panel.length === 0 ?
							''
							:
							panel.map( (target, index) => {
								return <List.Item key={ index }>
										{
											target.intact
											?
											<List.Content floated='right'>
												<Link to={ '/editPanelTarget/' + target.license }>
													<Popup content='Célpont módosítása' trigger={<Button icon basic color='blue'><Icon name='edit'/></Button>}></Popup>
												</Link>
												<Link to={ '/addAddress/' + target.license }>
													<Popup content='Címmódosítás, új cím felvétele' trigger={<Button icon basic color='blue'><Icon name='home'/></Button>}></Popup>
												</Link>
												<Popup content='Célpont törlése' trigger={<Button disabled={ !this.state.isPanelOpen && !isPanelChangePeriod() } icon onClick={ () => this.handleShowConfirmRemoveTarget(target.license) } color='red'><Icon name='trash'/></Button>}></Popup>
											</List.Content>
											:
											<Link to='/showChanges'><Button size='small' floated='right' basic>Kérés leadva</Button></Link>
										}
									<List.Content>
										<b title={ 'Position in panel: ' + (index + 1) }>{ target.name }</b>
										&nbsp;<Label 
											size='small' 
											basic 
											color={target.segmentation && target.segmentation !== 'NA' ? 'green' : undefined}
										>
											{ target.segmentation || 'NA' }
										</Label>
										&nbsp;
										<List.Description>
											<span className="panel-list-meta" style={{ color: '#444' }}>{ target.myPreferredSpecialtyHu || 'NA' } ({ target.license })</span>
											{/*<br/>
											{ target.city }, { target.postalCode }, { target.address }*/}
										</List.Description>							
									</List.Content>
									</List.Item>
							}, this)
						}
						</List>
					</Grid.Column>							
				<Grid.Column width={4} verticalAlign='top'>
					<SegmentationCharts panelData={this.props.actualPanel} />
				</Grid.Column>
				</Grid.Row>
			</Grid>					
			<Divider/>
			<span>Összesen <b>{ panel.length }</b> célpont.</span>
			<Link to='/showChanges'><Button floated='right' primary><Icon name='exchange' /> Igények áttekintése</Button></Link>
			<br/><br/>
			<Confirm
				open={ this.state.openRemoveTargetDialog }
				onCancel={ this.handleCloseConfirmRemoveTarget }
				cancelButton='Mégsem'
				content='Biztosan törlöd ezt a paneltagot?'
				confirmButton='Igen'
				onConfirm={ this.handleConfirmedRemoveTarget }
			></Confirm>
		</Segment>
	}
}